// bao migrate skip
import * as $ from "jquery";
import * as ko from "knockout";
var vm = function () {
    var self = this;
    self.DashBoardDate = null;
    self.hasPermissionSuffix = function (actionKey, suffix) {
        return actionKey.indexOf(suffix, actionKey.length - suffix.length) !== -1;
    };
    self.MessageKeys = {
        ConfirmIsReportClosed: "ConfirmIsReportClosed",
        InfoDeleteQuestion: "InfoDeleteQuestion",
        InfoDeleteSuccessful: "InfoDeleteSuccessful",
        InfoDeleteError: "InfoDeleteError",
        InfoBlindCopyQuestion: "InfoBlindCopyQuestion",
        InfoBlindCopyCurrentQuestion: 'InfoBlindCopyCurrentQuestion',
        InfoBlindCopySuccessful: "InfoBlindCopySuccessful",
        InfoBlindCopyError: "InfoBlindCopyError",
        InfoTransferCopyQuestion: 'InfoTransferCopyQuestion',
        InfoTransferCopyCurrentQuestion: 'InfoTransferCopyCurrentQuestion',
        InfoTransferCopySuccessful: 'InfoTransferCopySuccessful',
        InfoTransferCopyError: 'InfoTransferCopyError',
        InfoSaveQuestion: "InfoSaveQuestion",
        InfoSaveSuccessful: "InfoSaveSuccessful",
        InfoSaveError: "InfoSaveError",
        SaveCheck: "SaveCheck",
        TaskSaveSuccessful: "TaskSaveSuccessful",
        TaskSaveError: "TaskSaveError",
        TaskApproveSuccessful: "TaskApproveSuccessful",
        TaskApproveError: "TaskApproveError",
        TaskRejectSuccessful: "TaskRejectSuccessful",
        TaskRejectError: "TaskRejectError",
        TaskDeleteSuccessful: "TaskDeleteSuccessful",
        TaskDeleteError: "TaskDeleteError",
        TaskDeleteQuestion: "TaskDeleteQuestion",
        TaskFinishQuestion: "TaskFinishQuestion",
        TaskFinishSuccessful: "TaskFinishSuccessful",
        TaskFinishError: "TaskFinishError",
        TaskInProgressQuestion: 'TaskInProgressQuestion',
        TaskInProgressSuccessful: 'TaskInProgressSuccessful',
        TaskInProgressError: 'TaskInProgressError',
        Task: "Task",
        Info: "Info",
        CheckRequiredFields: "CheckRequiredFields",
        InstructionSaveSuccessful: "InstructionSaveSuccessful",
        InstructionSaveError: "InstructionSaveError",
        InstructionApproveSuccessful: "InstructionApproveSuccessful",
        InstructionApproveError: "InstructionApproveError",
        InstructionRejectSuccessful: "InstructionRejectSuccessful",
        InstructionRejectError: "InstructionRejectError",
        InstructionFinishQuestion: "InstructionFinishQuestion",
        InstructionFinishSuccessful: "InstructionFinishSuccessful",
        InstructionFinishError: "InstructionFinishError",
        InstructionReadQuestion: "InstructionReadQuestion",
        InstructionReadSuccessful: "InstructionReadSuccessful",
        InstructionReadError: "InstructionReadError",
        InstructionDeleteQuestion: "InstructionDeleteQuestion",
        InstructionDeleteSuccessful: "InstructionDeleteSuccessful",
        InstructionDeleteError: "InstructionDeleteError",
        WhiteboardDeleteQuestion: "WhiteboardDeleteQuestion",
        WhiteboardDeleteError: "WhiteboardDeleteError",
        WhiteboardDeleteSuccessful: "WhiteboardDeleteSuccessful",
        SaveSuccessful: "SaveSuccessful",
        SaveError: "SaveError",
        WhiteboardMarkAsReadQuestion: "WhiteboardMarkAsReadQuestion",
        WhiteboardMarkAsReadSuccessful: "WhiteboardMarkAsReadSuccessful",
        WhiteboardMarkAsReadError: "WhiteboardMarkAsReadError",
        WhiteboardAlreadyMarked: "WhiteboardAlreadyMarked",
        ReportNextReportIdError: "ReportNextReportIdError",
        RoleTaskRecipientRoleDeletePrompt: "RoleTaskRecipientRoleDeletePrompt",
        RoleInstructionRecipientRoleDeletePrompt: "RoleInstructionRecipientRoleDeletePrompt",
        AddEventToClosedReport: "AddEventToClosedReport",
        CreateNotificationQuestion: "CreateNotificationQuestion",
        ReportGetByDateError: "ReportGetByDateError",
        BriefingSaveSuccessful: "BriefingSaveSuccessful",
        BriefingSaveError: "BriefingSaveError",
        BriefingReadQuestion: "BriefingReadQuestion",
        BriefingReadSuccessful: "BriefingReadSuccessful",
        BriefingReadError: "BriefingReadError",
        BriefingDeleteQuestion: "BriefingDeleteQuestion",
        BriefingDeleteSuccessful: "BriefingDeleteSuccessful",
        BriefingDeleteError: "BriefingDeleteError"
    };
    self.ReportTypeIds = {
        ShiftReport: "7a342607-f69f-4e39-a857-9d4e48f4d589",
        SummaryReport: "7ba15f73-6330-4f89-a347-2ad1e566ad01",
        TaskReport: "25ba72ee-f2d2-40d2-b941-7fe475b4759a",
        InstructionReport: "a538e76f-ed4a-47e9-977d-c1c4493e189b",
        WhiteboardReport: "576df72e-eca8-440f-bc5a-9efe54437b83"
    };
    self.InstructionTypeIds = {
        ValidToFinished: "4e76f654-8882-4b01-8f86-3d5d87b518de",
        ValidFromTo: "e1a288f5-ad2a-4d53-9858-f30f4a7216a1",
        ValidFromToOrFinished: "3e76f654-8882-4b01-8f86-3d5d87b518de",
        FinishTill: "1fb17a8b-8354-4811-a49f-a599055df842"
    };
    self.WhiteboardTypeIds = {
        ValidNoEndDate: "14f82037-2d1a-4da3-8466-2940a1a5e322",
        ValidFromTo: "52e0252e-ce1d-4418-9eee-bdc0cc245037"
    };
    self.Filter = function (items, sorting, filter, pageIndex, pageSize) {
        if (sorting && sorting.length > 0) {
            var sortKey = sorting[0].Column;
            return ko.utils.arrayFilter(items, filter).sort(function (left, right) {
                if (left[sortKey]() === right[sortKey]()) {
                    return 0;
                }
                else if (left[sortKey]() > right[sortKey]()) {
                    if (sorting[0].Direction === "Ascending") {
                        return 1;
                    }
                    else {
                        return -1;
                    }
                }
                else {
                    if (sorting[0].Direction === "Ascending") {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }
            }).splice(pageSize * pageIndex, pageSize);
        }
        else {
            return ko.utils.arrayFilter(items, filter).splice(pageSize * pageIndex, pageSize);
        }
    };
    self.AdjustPageIndex = function (pageIndexObservable, pageSize, totalRows) {
        var pageIndex = pageIndexObservable();
        if (pageSize * pageIndex >= totalRows) {
            var currentPageIndex = pageIndex;
            if (currentPageIndex != 0) {
                pageIndexObservable(pageIndex - 1);
            }
        }
    };
    self.InsertAtCursorPosition = function (textarea, value) {
        if (document.selection) {
            textarea.focus();
            var sel = document.selection.createRange();
            sel.text = value;
        }
        else if (textarea.selectionStart || textarea.selectionStart == "0") {
            var startPos = textarea.selectionStart;
            var endPos = textarea.selectionEnd;
            textarea.value = textarea.value.substring(0, startPos) + value + textarea.value.substring(endPos, textarea.value.length);
        }
        else {
            textarea.value += value;
        }
        $(textarea).change();
    };

    self.InsertAtCursorPositionContentEditable = function (cediv, text) {
        var sel, range;
        if (window.getSelection) {
            cediv.focus();
            sel = window.getSelection();
            if (sel.getRangeAt && sel.rangeCount) {
                range = sel.getRangeAt(0);
                range.deleteContents();
                range.insertNode(document.createTextNode(text));
            }
        } else if (document.selection && document.selection.createRange) {
            document.selection.createRange().text = text;
        }
    }
    self.setTextToUserTaggingInput = (div, text, isHistory: boolean) => {
        if (div != undefined) {
            if (isHistory)
            {
                div.setAttribute("readonly", "readonly");
            }
            else
            {
                div.removeAttribute("readonly");
            }
            div.innerHTML = text;
        }
    }
};
export default new vm();